import React, { useState } from "react";
import { Row, Space, Typography } from "antd";
import CopyLinkBtn from "./CopyLinkBtn";
import Download from "./Download";
import Edit from "./Edit";
import PreviewBtn from "./Preview";
import MoreOptions from "./MoreOptions";
import LinkSecurityIcon from "./LinkSecurityIcon";
import utils from "routes/SourceWiz/CreateCollection/LinkSettings/utils";
import moment from "moment";
import Can from "../../../../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
const { Text, Title } = Typography;

const Controls = ({
  text,
  row,
  index,
  deleteCatalogue,
  activateCatalogue,
  deactivateCatalogue,
  showModal,
  linkSecurityData,
}) => {
  const [data, updateLinkSecurityData] = useState(linkSecurityData);
  const [greyBoxData, setGreyBoxData] = useState(
    utils.getGreyBoxData(linkSecurityData?.security_data)
  );

  const handleUpdateLinkSecurityData = (greyBoxData, data) => {
    updateLinkSecurityData(data);
    const gd = utils.getGreyBoxData(data.security_data);
    setGreyBoxData(gd);
  };
  const expiryText = utils.getExpiryText(data);
  return (
    <Row justify="end">
      <Space>
        {data?.id &&
          utils.isLinkSecure(data.security_data) &&
          row?.status === "published" && (
            <LinkSecurityIcon text={text} greyBoxData={greyBoxData} />
          )}

        <Can
          I={PERMISSIONS.download_ppt_excel.slug }
          a={PERMISSIONS.download_ppt_excel.permissionType}
        >
          {row?.status !== "draft" && (
            <div
              style={{
                marginTop:
                  expiryText && row?.status !== "inactive" ? "25px" : 0,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CopyLinkBtn text={text} />
              {expiryText && row?.status !== "inactive" && (
                <Text
                  style={{
                    fontSize: "12px",
                    paddingTop: 5,
                    color: "rgba(0, 0, 0, 0.45)",
                  }}
                >
                  {expiryText}
                </Text>
              )}
            </div>
          )}
         
        </Can>

        <Can    I={PERMISSIONS.download_ppt_excel.slug}
          a={PERMISSIONS.download_ppt_excel.permissionType}>
        {row?.status !== "draft" && <PreviewBtn text={text} />}
        </Can>


        <Can
          I={PERMISSIONS.download_ppt_excel.slug}
          a={PERMISSIONS.download_ppt_excel.permissionType}
        >
          {row?.status !== "draft" && <Download text={text} />}
        </Can>
        <Can
          I={PERMISSIONS.update_catalogues.slug}
          a={PERMISSIONS.update_catalogues.permissionType}
        >
          {row?.status === "draft" && <Edit text={text} />}
        </Can>
       {/* <Can
         I={PERMISSIONS.update_catalogues_link_security.slug||PERMISSIONS.create_catalogues.slug||PERMISSIONS.delete_catalogues.slug}
         a={PERMISSIONS.create_catalogues.permissionType}
         > */}
       <MoreOptions
          // deactivateCatalogue={deactivateCatalogue}
          // deleteCatalogue={deleteCatalogue}
          showModal={showModal}
          activateCatalogue={activateCatalogue}
          row={row}
          text={text}
          linkSecurityData={data}
          handleUpdateLinkSecurityData={handleUpdateLinkSecurityData}
        />
       {/* </Can> */}
      </Space>
    </Row>
  );
};

export default Controls;
